"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LftTypography_1 = __importDefault(require("../LftTypography"));
var LftButtonGroup_1 = __importDefault(require("../LftButtonGroup"));
var S = __importStar(require("./LftDrawerContent.styles"));
var LftDrawerContent = function (_a) {
    var bgColor = _a.bgColor, _b = _a.buttonPrimaryLabel, buttonPrimaryLabel = _b === void 0 ? 'Button Primary' : _b, _c = _a.buttonTertiaryLabel, buttonTertiaryLabel = _c === void 0 ? 'Button Secondary' : _c, dataSection = _a.dataSection, description = _a.description, id = _a.id, size = _a.size, title = _a.title, _d = _a.visible, visible = _d === void 0 ? false : _d, lftClickCancel = _a.lftClickCancel, lftClickConfirm = _a.lftClickConfirm;
    var _e = (0, react_1.useState)(visible), contentVisible = _e[0], setContentVisible = _e[1];
    var dataElement = dataSection === null || dataSection === void 0 ? void 0 : dataSection.replace('section_', '');
    (0, react_1.useEffect)(function () {
        setContentVisible(visible);
    }, [visible]);
    var _handleConfirm = function (e) {
        lftClickConfirm && lftClickConfirm(e);
    };
    var _handleCancel = function (e) {
        lftClickCancel && lftClickCancel(e);
    };
    if (dataSection) {
        if (dataSection.startsWith('section_')) {
            console.warn('Não é necessário mais o prefixo section_ no atributo dataSection');
        }
        else
            (dataSection = "section_" + dataSection);
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !!contentVisible && ((0, jsx_runtime_1.jsxs)(S.Wrapper, __assign({ bgColor: bgColor, "data-lift": "lft-drawer-content", "data-section": dataSection, id: id, visible: visible }, { children: [(0, jsx_runtime_1.jsxs)("label", __assign({ "aria-label": title ? 'Heading' : 'Description', "data-lift": "lft-input-label" }, { children: [(0, jsx_runtime_1.jsx)(LftTypography_1.default, __assign({ component: 'title', size: 'small', variant: 'h1' }, { children: title }), void 0), (0, jsx_runtime_1.jsx)(LftTypography_1.default, __assign({ component: 'paragraph', size: 'small', variant: 'h1' }, { children: description }), void 0)] }), void 0), (0, jsx_runtime_1.jsx)(LftButtonGroup_1.default, { buttonPrimaryDataElement: dataSection && ('primary-' + dataElement), buttonPrimaryLabel: buttonPrimaryLabel, buttonTertiaryDataElement: dataSection && ('tertiary-' + dataElement), buttonTertiaryLabel: buttonTertiaryLabel, size: size, lftClickPrimary: _handleConfirm, lftClickTertiary: _handleCancel }, void 0)] }), void 0)) }, void 0));
};
exports.default = LftDrawerContent;
